<app-header></app-header>
<!-- <splash-screen
  [animationType]="SplashAnimationType.FadeOut"
  [duration]="2"
  [animationDuration]="3">
</splash-screen> -->
<router-outlet></router-outlet>
<app-footer></app-footer>
<cookie-message></cookie-message>
